export const packNetNav = "#022B3D";

export const limeMain = "#B0D945";
export const coralMain = "#D25A49";
export const skyBlueMain = "#A2E3FF";

export const primaryMain = "#0068AB";
export const primaryLight = "#0588DD";
export const slateBlueMain = "#3A4C54";

export const backgroundDefault = "#ECF1F0";
export const backgroundPaper = "#FCFCFC";

export const backgroundDefaultDark = "#0D1B26";
export const backgroundPaperDark = "#152535";

export const textPrimary = "#353430";
export const textSecondary = "#7C7B79";
export const textDisabled = "#A2ADB3";

export const textPrimaryDark = "#F0F0EF";
export const textSecondaryDark = "#A2ADB3";
export const textDisabledDark = "#5C6B75";

export const errorMain = "#FF3743";
export const warningMain = "#FFC000";
export const successMain = "#7ED321";
export const infoMain = "#7C7B79";
